/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkLookupReleaseResponseRecordingsInner } from './BulkLookupReleaseResponseRecordingsInner';
import {
    BulkLookupReleaseResponseRecordingsInnerFromJSON,
    BulkLookupReleaseResponseRecordingsInnerFromJSONTyped,
    BulkLookupReleaseResponseRecordingsInnerToJSON,
} from './BulkLookupReleaseResponseRecordingsInner';
import type { LookupReleaseResponsePayload } from './LookupReleaseResponsePayload';
import {
    LookupReleaseResponsePayloadFromJSON,
    LookupReleaseResponsePayloadFromJSONTyped,
    LookupReleaseResponsePayloadToJSON,
} from './LookupReleaseResponsePayload';

/**
 * 
 * @export
 * @interface BulkLookupReleaseResponse
 */
export interface BulkLookupReleaseResponse {
    /**
     * 
     * @type {LookupReleaseResponsePayload}
     * @memberof BulkLookupReleaseResponse
     */
    payload: LookupReleaseResponsePayload;
    /**
     * 
     * @type {Array<BulkLookupReleaseResponseRecordingsInner>}
     * @memberof BulkLookupReleaseResponse
     */
    recordings: Array<BulkLookupReleaseResponseRecordingsInner>;
}

/**
 * Check if a given object implements the BulkLookupReleaseResponse interface.
 */
export function instanceOfBulkLookupReleaseResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payload" in value;
    isInstance = isInstance && "recordings" in value;

    return isInstance;
}

export function BulkLookupReleaseResponseFromJSON(json: any): BulkLookupReleaseResponse {
    return BulkLookupReleaseResponseFromJSONTyped(json, false);
}

export function BulkLookupReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkLookupReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payload': LookupReleaseResponsePayloadFromJSON(json['payload']),
        'recordings': ((json['recordings'] as Array<any>).map(BulkLookupReleaseResponseRecordingsInnerFromJSON)),
    };
}

export function BulkLookupReleaseResponseToJSON(value?: BulkLookupReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payload': LookupReleaseResponsePayloadToJSON(value.payload),
        'recordings': ((value.recordings as Array<any>).map(BulkLookupReleaseResponseRecordingsInnerToJSON)),
    };
}

